/**
 * BeCoder — final brand constants (identity only; no product logic).
 *
 * Mark name: "The Channel"
 * Signal: BeCoder Ember #FF4F00
 * Ink: #0A0A0B
 */

export const BRAND_NAME = 'BeCoder';

/** Primary signal accent — BeCoder Ember */
export const BRAND_SIGNAL = '#FF4F00';
/** Legacy alias kept for gradual migration */
export const BRAND_ORANGE = BRAND_SIGNAL;

/** Near-black ink */
export const BRAND_INK = '#0A0A0B';
/** Legacy alias */
export const BRAND_NAVY = BRAND_INK;

/** Paper / light canvas */
export const BRAND_PAPER = '#FAFAF9';

export const BRAND_TAGLINE = {
  en: 'Secure software distribution',
  ar: 'توزيع آمن للبرامج',
  ckb: 'دابەشکردنی پارێزراوی سۆفتوێر',
} as const;

export const BRAND_MISSION = {
  en: 'BeCoder is the central storefront for our software — discover products, review pricing, and license what fits your business.',
  ar: 'BeCoder هو المتجر المركزي لبرمجياتنا — اكتشف المنتجات، راجع الأسعار، واحصل على الترخيص الذي يناسب عملك.',
  ckb: 'BeCoder فرۆشگای سەرەکیی سۆفتوێرەکانمانە — بەرهەمەکان ببینە، نرخەکان بەراورد بکە، و ئەو مۆڵەتە وەربگرە کە بۆ کارەکەت گونجاوە.',
} as const;

/** Design tokens mirrored in CSS */
export const BRAND_TOKENS = {
  signal: BRAND_SIGNAL,
  signalHover: '#E64600',
  ink: BRAND_INK,
  inkElevated: '#141416',
  paper: BRAND_PAPER,
  fog: '#71717A',
  line: '#E4E4E7',
  lineDark: '#27272A',
  success: '#059669',
  warning: '#D97706',
  danger: '#DC2626',
  radiusSm: '4px',
  radiusMd: '8px',
  radiusLg: '12px',
  fontDisplay: '"Syne", "Manrope", sans-serif',
  fontSans: '"Manrope", "Noto Sans Arabic", sans-serif',
  fontMono: '"JetBrains Mono", ui-monospace, monospace',
} as const;
